import { render, staticRenderFns } from "./Resetpwd.vue?vue&type=template&id=5510111b&scoped=true&"
import script from "./Resetpwd.vue?vue&type=script&lang=js&"
export * from "./Resetpwd.vue?vue&type=script&lang=js&"
import style0 from "./Resetpwd.vue?vue&type=style&index=0&id=5510111b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5510111b",
  null
  
)

export default component.exports